import Products from './components/Products.vue';
import ProductModal from './components/productModal.vue';
import DeleteModal from './components/deleteModal.vue';
import Apps from './components/Apps.vue';
import AppModal from './components/appModal.vue';
import AppDetails from './components/AppDetails';
import ShowArticle from './components/ShowArticle.vue';
import EditArticle from './components/EditArticle.vue';
import Login from './components/Login.vue';
import NotFound from './components/NotFound.vue';
import SearchResults from './components/SearchResults.vue'

const routes = [{
	name: 'Login',
	path: '/login',
	component: Login
},
{
	name: 'NotFound',
	path: '/404',
	component: NotFound
},
{
	name: 'showProducts',
	path: '/',
	component: Products,
	children: [{
		name: 'newProductModal',
		path: '/new',
		components: {
			default: Products,
			modal: ProductModal
		},
	},
	{
		name: 'editProductModal',
		path: '/:productId/edit',
		components: {
			default: Products,
			modal: ProductModal
		}
	},
	{
		name: 'deleteProductModal',
		path: '/:productId/delete',
		components: {
			default: Products,
			modal: DeleteModal
		}
	}
	]
},
{
	name: 'searchResults',
	path: '/search',
	component: SearchResults
},
{
	name: 'showApps',
	path: '/:productId',
	component: Apps,
	children: [{
		name: 'newAppModal',
		path: '/:productId/new',
		components: {
			default: Apps,
			modal: AppModal
		}
	},
	{
		name: 'editAppModal',
		path: '/:productId/:appId/edit',
		components: {
			default: Apps,
			modal: AppModal
		}
	},
	{
		name: 'deleteAppModal',
		path: '/:productId/:appId/delete',
		components: {
			default: Apps,
			modal: DeleteModal
		}
	}
	]
},
{
	name: 'showAppDetails',
	path: '/:productId/:appId',
	component: AppDetails,
	children: [{
		name: 'showFirstArticleOfSection',
		path: '/:productId/:appId/:sectionId/',
		components: {
			default: AppDetails,
			articleView: ShowArticle
		}
	}, {
		name: 'showArticle',
		path: '/:productId/:appId/:sectionId/:articleId',
		components: {
			default: AppDetails,
			articleView: ShowArticle
		}
	}]
},
{
	name: 'editArticle',
	path: '/:productId/:appId/:sectionId/:articleId/edit',
	component: EditArticle
}
];

export default routes;